/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { CirclePicker } from 'react-color';
// import { IoIosArrowBack } from 'react-icons/io';
import { Loader } from 'react-overlay-loader';

export default function Editor() {
    const [loader, setLoader] = useState(false);
    const [svgContent, setSvgContent] = useState('');
    const [svgContentfinal, setSvgContentfinal] = useState('');
    const [savemsg, setSavemsg] = useState('');

    // const navigate = useNavigate()
    const location = useLocation()
    console.log("url", location.state.url)
    const url = location?.state?.url

    // const [pathColors, setPathColors] = useState({}); // State to store path colors
    const [selectedFontFamily, setSelectedFontFamily] = useState('');
    const [selectedFontSize] = useState(''); // Set an initial font size
    const [selectedColor] = useState('red'); // Initialize with a default color


    const svgid = location?.state?.svgid
    // const [ setInputValue] = useState('');
    const [inputValue, setInputValue] = useState('');
    const selectedPathRef = useRef(null);
    const selectedTextRef = useRef(null);
    const token = localStorage.getItem("token")
    // Retrieve the data from localStorage
    // const storedData = localStorage.getItem('data'); // Replace 'yourLocalStorageKey' with the actual key you used to store the data
    // Parse the JSON data
    // const parsedData = JSON.parse(storedData);
    // Extract the value of "svgCategoryId"
    // const svgCategoryId = parsedData.svgCategoryId;



    const columnStyle = {
        // flex: 1,
        padding: '12px',
        backgroundColor: 'rgb(249 249 249)', // Background color
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)', // Shadow
        fontWeight: "bold"
    };


    useEffect(() => {

        if (location.state.Data) {
            console.log('code',location.state.Data)
            setLoader(true)
            const svgContent = location.state.Data;
            const parser = new DOMParser();
            const doc = parser.parseFromString(svgContent, 'image/svg+xml');
            const pathElements = doc.querySelectorAll('path');
            const textElements = doc.querySelectorAll('text');
            // Set custom viewBox values
            const customViewBox = '50 0 400 400'; // Replace with your custom values
            doc.documentElement.setAttribute('viewBox', customViewBox);
            // const colors = {};
            setupPathAndTextClickListeners(pathElements, textElements);
            // setPathColors(colors);
            // Convert the parsed document back to an SVG string
            const serializer = new XMLSerializer();
            const simpleSvgString = serializer.serializeToString(doc);
            setSvgContent(simpleSvgString);
            window.scrollTo(0, 0);
            setLoader(false)

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Generate an array of font size options from 5px to 100pxF
    const fontSizeOptions = [];
    for (let size = 5; size <= 100; size += 5) {
        fontSizeOptions.push(`${size}px`);
    }

    // yaha selected path or text ko color krty haa 
    const setupPathAndTextClickListeners = (pathElements, textElements) => {
        pathElements.forEach((path, index) => {
            path.addEventListener('click', () => {
                path.setAttribute('fill', selectedColor); // Set the selected color for paths
            });
        });

        textElements.forEach((text, index) => {
            text.addEventListener('click', () => {
                text.setAttribute('fill', selectedColor); // Set the selected color for text elements
                text.setAttribute('font-family', selectedFontFamily); // Set the font family (change 'Arial' to the desired font)
                text.setAttribute('font-size', selectedFontSize); // Set the font size (change '16' to the desired size)
            });
        });
    };

    // Path selection 

    const handlePathClick = (event) => {


        // Get the clicked path element
        const clickedPath = event.target;

        // Check if the clicked path is different from the previously selected path
        const isPathSelected = clickedPath.classList.contains('selected');

        if (!isPathSelected) {
            // Unselect the previously selected path
            if (selectedPathRef.current) {
                selectedPathRef.current.classList.remove('selected');
            }

            // Select the new path
            clickedPath.classList.add('selected');
            selectedPathRef.current = clickedPath;
        } else {
            // Deselect the currently selected path
            clickedPath.classList.remove('selected');
            selectedPathRef.current = null;
        }
    };
    // text selection 

    // const handleTextClick = (event) => {
    //     const clickedText = event.target.closest('text');
    //        // Remove all existing styles (font family and font size)
    // clickedText.removeAttribute('style');
    //     console.log("clickedText")

    //     // Remove all classes from all text elements 
    //     const allTextElements = document.querySelectorAll('text');
    //     allTextElements.forEach((textElement) => { textElement.removeAttribute('class'); });

    //     if (selectedTextRef.current) {
    //         selectedTextRef.current.classList.remove('selected');
    //     }

    //     if (clickedText !== selectedTextRef.current) {
    //         console.log("edit")
    //         // Make the clicked text element editable
    //         clickedText.setAttribute('contentEditable', 'true');

    //         // Add 'selected' class to the clicked text element
    //         clickedText.classList.add('selected');

    //         // Focus on the clicked text element
    //         clickedText.focus();

    //         // Update the input box value
    //         setInputValue(clickedText.textContent);

    //         // Update the selectedTextRef.current
    //         selectedTextRef.current = clickedText;
    //     } else {
    //         // Remove 'contentEditable' attribute when clicking again
    //         clickedText.removeAttribute('contentEditable');
    //         selectedTextRef.current = null;
    //     }

    //     if (selectedPathRef.current) {
    //         selectedPathRef.current.classList.remove('selected');
    //     }
    // };

    const handleTextClick = (event) => {
        const clickedText = event.target.closest('text');
        // Remove all classes from all text elements
        const allTextElements = document.querySelectorAll('text');
        allTextElements.forEach((textElement) => {
            textElement.removeAttribute('class');
        });
    
        if (selectedTextRef.current) {
            selectedTextRef.current.classList.remove('selected');
        }
    
        if (clickedText !== selectedTextRef.current) {
            // Make the clicked text element editable
            clickedText.setAttribute('contentEditable', 'true');
    
            // Add 'selected' class to the clicked text element
            clickedText.classList.add('selected');
    
            // Focus on the clicked text element
            clickedText.focus();
    
            // Update the input box value
            setInputValue(clickedText.textContent);
    
            // Extract font-size from the existing style attribute
            let fontSize = ''; // Set a default font size if not present
            const styleAttribute = clickedText.getAttribute('style');
    
            if (styleAttribute) {
                const styleProperties = styleAttribute.split(';');
                styleProperties.forEach(property => {
                    const [key, value] = property.trim().split(':');
                    if (key === 'font-size') {
                        fontSize = value.trim();
                    }
                });
            }
    
            // Remove the existing style attribute
            clickedText.removeAttribute('style');
    
            // Set the extracted font-size directly to the text element
            if (fontSize) {
                clickedText.setAttribute('font-size', fontSize);
            }
    
            // Update the selectedTextRef.current
            selectedTextRef.current = clickedText;
        } else {
            // Remove 'contentEditable' attribute when clicking again
            clickedText.removeAttribute('contentEditable');
            selectedTextRef.current = null;
        }
    
        if (selectedPathRef.current) {
            selectedPathRef.current.classList.remove('selected');
        }
    };


    // selected path ka color change hona 
    const handleColorChange = (newColor) => {
        console.log("new color", newColor)
        if (selectedPathRef.current) {
            selectedPathRef.current.style.fill = newColor.hex;
        }
        if (selectedTextRef.current) {
            selectedTextRef.current.style.fill = newColor.hex;
        }
    };

    // selected font ka fontfamily cha nge hona 
    const updateFontFamily = (event) => {
        console.log("check", event)
        // const selectedValue = event.target.value;
        setSelectedFontFamily(event);
        if (selectedTextRef.current) {
            selectedTextRef.current.setAttribute('font-family', event);
        }
    };


    // images k path or text ko change krny k liye useEffect 
    useEffect(() => {
        // Get the SVG container element
        const svgContainer = document.getElementById('svg-container');
        // Add click event listeners to all the paths within the container
        const paths = svgContainer.querySelectorAll('path');
        const texts = svgContainer.querySelectorAll('text');

        paths.forEach((path) => {
            path.addEventListener('click', handlePathClick);
        });

        texts.forEach((text) => {
            text.addEventListener('click', handleTextClick);
        });

        return () => {
            // Cleanup: Remove event listeners when the component unmounts
            paths.forEach((path) => {
                path.removeEventListener('click', handlePathClick);
            });

            texts.forEach((text) => {
                text.removeEventListener('click', handleTextClick);
            });
        };
    }, [handlePathClick, handleTextClick]);


    // updated logo 
    const Placementpage = () => {
        const svgContents = document.getElementById('svg-container').innerHTML; // Assuming you have an SVG container with the id 'svg-container'
        setSvgContentfinal(svgContents)

    }

    const CloseAddmodal = () => {
        const deletemodal = document.getElementById("staticBackdropadd");

        // Simulate a click on the close button to close the modal
        const closeBtn = deletemodal.querySelector('[data-bs-dismiss="modal"]');
        closeBtn.click();

        const previewButton = document.getElementById("previewButton");
        previewButton.click();

    }

    const SaveLogo = async () => {
        setLoader(true)
        window.scroll(0, 0)
        // Create a Blob from the SVG content
        const svgBlob = new Blob([svgContentfinal], { type: 'image/svg+xml' });
        // Create a File object from the Blob
        const svgFile = new File([svgBlob], 'logo.svg', { type: 'image/svg+xml' });
        console.log(svgFile)
        const formData = new FormData();  // Corrected typo from Formdata to FormData
        formData.append("logo", svgFile);
        formData.append("svg_id", svgid);
        formData.append("url", url);


        try {
            const response = await fetch(`https://fhbapi.devssh.xyz/api/v1/logo_details/save_logo_webview/`, {
                method: 'POST',
                headers: {
                  
                    'Authorization': `Bearer ${token}`
                },
                body: formData  // Send the FormData object directly
            });

            const data = await response.json();
            setLoader(false)

            setSavemsg(data.message)
            // Parse the URL
            CloseAddmodal()
            const urlObject = new URL(data.url);
            // Remove the unwanted part
            const cleanedURL = `${urlObject.pathname}${urlObject.search}${urlObject.hash}`;
            console.log(cleanedURL);

            // navigate(cleanedURL)
            // navigate('/?family_last_name=hnh%20soft%20tech&slogan=your%20pottential&colour_code=B7B7B7&svg_category_id=2b271d72-02c5-4153-9f4e-956ec1cfdcd1&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImYxNjgxZGM5LWM5YmItNGJkYS1hYzY1LWExMmMyNDE4YmNlZCIsImVtYWlsIjoiZmFpekBnbWFpbC5jb20iLCJleHAiOjE3MDkzNzEyMjYsImlhdCI6MTcwOTI4NDgyNn0.n-0OevN1NbpwlxvLm9adMYswAV4bqXQblqnqxFhEUkM')
            console.log(data)
        } catch (error) {
            setLoader(false)

            console.error('Error fetching data:', error);
        }
    };

    return (
        <>
            {loader === true ? <Loader fullPage loading /> : null}

            <main className="main_wrapper overflow-hidden">
                <section className="shop__page__wrap ">
                    <div className="container-fluid full__width__padding">
                        {/* <button type='button' className='btn' onClick={()=>navigate("/logocategory")}>   <IoIosArrowBack size={20} /> </button> */}


                        <div className="row ">

                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="tab-content" id="myTabContent" data-aos="fade-up">

                                    <div className="tab-pane fade active show" id="list_view">
                                        <div className="row d-flex justify-content-center align-items-center flex-column">
                                            <button id="previewButton" style={{ display: "none" }} data-bs-toggle="modal" data-bs-target="#staticBackdropsuccess" className="btn btn-primary fixed-width-btn-prm ">Preview</button>


                                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 column__custom__class ' >
                                                <div className="gridarea__wraper product__grid ">
                                                    <div className="gridarea__img">

                                                        <div
                                                            id="svg-container"
                                                            dangerouslySetInnerHTML={{ __html: svgContent }}


                                                        />



                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 column__custom__class'>
                                                <div className='gridarea__wraper product__grid'>

                                                    <div style={{ display: 'flex', justifyContent: "space-around" }}>
                                                        <div onClick={() => updateFontFamily("Georgia,serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Georgia</div>
                                                        <div onClick={() => updateFontFamily("Palatino Linotype,Book Antiqua,Palatino,serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Palatino</div>
                                                        <div onClick={() => updateFontFamily("Times New Roman,Times,serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Times</div>
                                                        <div onClick={() => updateFontFamily("Arial,Helvetica,sans-serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Arial</div>
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: "space-around", marginTop: "4px" }}>
                                                        <div onClick={() => updateFontFamily("Comic Sans MS,cursive,sans-serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Comic</div>
                                                        <div onClick={() => updateFontFamily("Impact,Charcoal,sans-serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Impact</div>
                                                        <div onClick={() => updateFontFamily("Tahoma,Geneva,sans-serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Tahoma</div>
                                                        <div onClick={() => updateFontFamily("Verdana,Geneva,sans-serif")} value={selectedFontFamily} className='fontbox' style={columnStyle}>Verdana</div>


                                                    </div>
                                                </div>


                                            </div>

                                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 column__custom__class ' >
                                                <div className='gridarea__wraper product__grid' >
                                                    <div className="gridarea__img d-flex justify-content-center align-items-center">
                                                        <CirclePicker onChange={handleColorChange} width='500px' circleSize={40} />

                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    </div>


                                </div>

                                <div className="fixed-buttons d-flex justify-content-center align-item-center">
                                    {/* <button  className="btn btn-secondary mx-1 fixed-width-btn-sec">Re-Generate</button> */}
                                    <button onClick={Placementpage} data-bs-toggle="modal" data-bs-target="#staticBackdropadd" className="btn btn-primary fixed-width-btn-prm ">Preview</button>
                                    {/* <button onClick={Placementpage}  className="btn btn-primary fixed-width-btn-prm ">no</button> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* ADD MODAL  */}
            <div class="modal fade" id="staticBackdropadd" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">Preview Your Logo</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>

                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 column__custom__class ' >
                                    <div className="gridarea__wraper product__grid ">
                                        <div className="gridarea__img">
                                            <Link to="">
                                                <div
                                                    id="svg-container"
                                                    dangerouslySetInnerHTML={{ __html: svgContentfinal }}


                                                />
                                            </Link>


                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button onClick={() => SaveLogo()} type='button' className="btn btn-primary fixed-width-btn-prm">
                                {loader ? 'Saving...' : 'Save'}
                            </button>
                            {/* <button onClick={() => SaveLogo()} type='button' className="btn btn-primary fixed-width-btn-prm ">Save</button> */}
                            <button className="btn btn-secondary mx-1 fixed-width-btn-sec" data-bs-dismiss="modal">Cancel</button>

                        </div>
                    </div>
                </div>
            </div>


            {/* success MODAL  */}
            <div class="modal fade" id="staticBackdropsuccess" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            {/* <h5 className="modal-title" id="staticBackdropLabel"></h5> */}
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <h1>{savemsg}</h1>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button className="btn btn-secondary mx-1 fixed-width-btn-sec" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
